// UserContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import { jwtDecode } from "jwt-decode";

const UserContext = createContext();

/* Imposto dati login utente */
export const UserProvider = ({ children }) => {

  const navigate = useNavigate();

  const [username, setUsername] = useState(null);
  const [role, setRole]         = useState(null);

  // Legge token al primo caricamento
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUsername(decoded.sub);
        setRole(decoded.role);
      } catch (err) {
        console.error("Token non valido:", err);
        localStorage.removeItem("token");
      }
    }
  }, []);

  // Funzione di logout centralizzata
  const logout = () => {
    localStorage.removeItem("token");
    setUsername(null);
    setRole(null);
    navigate("/"); 
  };

  return (
    <UserContext.Provider value={{ username, role, setUsername, setRole, logout }}>
      {children}
    </UserContext.Provider>
  );
};


/* Esporto utente */
export const useUser = () => useContext(UserContext);
